<template>
  <section class="login-page">
    <div class="login-title">控客后台服务-管理端</div>
    <div class="login-content">
      <img class="login-bg" src="@/assets/images/login/login-bg.png" alt="" />
      <div class="content-form">
        <h1>用户登录</h1>
        <div class="form-box">
          <a-form :form="form">
            <a-form-item>
              <a-input v-model="form.username" placeholder="请输入登录帐号" size="large">
                <app-icon type="icon-zhanghaodenglu" slot="prefix"></app-icon>
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input-password v-model="form.password" placeholder="请输入登录密码" size="large">
                <app-icon type="icon-mima" slot="prefix"></app-icon>
              </a-input-password>
            </a-form-item>
            <a-form-item>
              <a-input
                v-model="form.code"
                placeholder="请输入图形验证码"
                size="large"
                class="code-input"
                @keypress.enter="handleSubmit"
              >
                <template #suffix>
                  <auto-img :src="codeSrc" class="code-img" @click.native="loadCode"></auto-img>
                </template>
              </a-input>
            </a-form-item>
            <a-form-item class="err-msg-form">
              <div class="err-msg">{{ errMsg }}</div>
            </a-form-item>
            <a-form-item>
              <a-button @click="handleSubmit" :loading="loading" class="login-btn">登录</a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      form: {
        username: '',
        password: '',
        code: '',
        codeId: '',
      },

      errMsg: '',
      codeSrc: '',
      loading: false,
    }
  },
  mounted() {
    this.loadCode()
  },
  methods: {
    resetError() {
      this.errMsg = ''
    },
    checkInput() {
      const { username, password, code, codeId } = this.form

      if (!username) {
        this.errMsg = '请输入账号'
        return false
      }

      if (!password) {
        this.errMsg = '请输入密码'
        return false
      }
      if (!code) {
        this.errMsg = '请输入验证码'
        return false
      }
      if (!codeId) {
        this.errMsg = '验证码获取失败'
        return false
      }
      return true
    },
    async handleSubmit(e) {
      if (!this.checkInput()) {
        return false
      }
      this.loading = true
      try {
        const res = await this.$store.dispatch('Login', this.form)
        await this.loginSuccess(res)
      } catch (e) {
        this.requestFailed(e)
      }
      this.loading = false
    },
    async loginSuccess(res) {
      const toPath = decodeURIComponent(this.$route.query.redirect || '/')
      setTimeout(() => {
        this.$notification.success({
          message: '登陆成功',
          description: `欢迎回来`,
        })
      })
      await this.$router.replace(toPath).catch(e => {
        // console.log(e)
      })
    },
    requestFailed(err) {
      this.errMsg = err.message
      this.form.code = ''
      this.loadCode()
    },
    async loadCode() {
      const res = await this.$axios.get('/user/admin/account/getVerify')
      this.codeSrc = res.data.picBase64Str
      this.form.codeId = res.data.codeId
    },
  },
}
</script>
<style lang="less" scoped>
.login-page {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-image: url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20baseProfile='full'%20width='100%25'%20height='100%25'%20viewBox='0%200%201400%20800'%3e%3cstyle%3e%20:root%20{%20--blue:%20rgba(64,%20158,%20255,%200.08);%20--grey:%20rgba(144,%20147,%20153,%200.05);%20--orange:%20rgba(230,%20162,%2060,%200.06);%20--green:%20rgba(144,%20238,%20144,%200.06);%20}%20@media%20(prefers-color-scheme:%20dark)%20{%20:root%20{%20--blue:%20rgba(64,%20158,%20255,%200.04);%20--grey:%20rgba(144,%20147,%20153,%200.03);%20--orange:%20rgba(230,%20162,%2060,%200.04);%20--green:%20rgba(144,%20238,%20144,%200.04);%20}%20}%20%3c/style%3e%3c!--%20%E5%B7%A6%E4%BE%A7%E6%B3%A2%E6%B5%AA%20--%3e%3cpath%20d='M-50%20550%20Q200%20500%20450%20550%20T950%20530'%20fill='none'%20stroke='%23409EFF'%20stroke-width='1.5'%20stroke-opacity='0.05'%20stroke-linecap='round'%3e%3c/path%3e%3c!--%20%E5%8F%B3%E4%BE%A7%E6%B3%A2%E6%B5%AA%20--%3e%3cpath%20d='M450%20650%20Q800%20620%201150%20660%20T1550%20630'%20fill='none'%20stroke='%23909399'%20stroke-width='1'%20stroke-opacity='0.03'%20stroke-linecap='round'%3e%3c/path%3e%3c!--%20%E5%8F%B3%E4%B8%8B%E6%96%B9%E5%9C%86%E5%BD%A2%20--%3e%3ccircle%20cx='950'%20cy='400'%20r='70'%20fill='var(--blue)'%20stroke='%23409EFF'%20stroke-width='1'%20stroke-opacity='0.05'%3e%3c/circle%3e%3c!--%20%E5%B7%A6%E4%B8%8A%E6%96%B9%E5%8D%8A%E7%90%83%E5%BD%A2%20--%3e%3cg%20transform='rotate(-10,%20300,%20180)'%3e%3cpath%20d='M%20180%20180%20A%20120%20120%200%201%201%20420%20180%20Q420%20195%20405%20195%20L%20310%20195%20L%20195%20195%20Q180%20195%20180%20180'%20fill='var(--orange)'%20stroke='%23E6A23C'%20stroke-width='1'%20stroke-opacity='0.05'%3e%3c/path%3e%3c/g%3e%3c!--%20%E5%B7%A6%E4%B8%8B%E6%96%B9%E4%B8%89%E8%A7%92%E5%BD%A2%20--%3e%3cpath%20d='M300%20600%20L380%20520%20L420%20650%20Z'%20fill='var(--green)'%20stroke='%23909399'%20stroke-width='1'%20stroke-opacity='0.04'%3e%3c/path%3e%3c!--%20%E6%97%8B%E8%BD%AC%E6%96%B9%E5%9D%97%20--%3e%3crect%20x='1000'%20y='420'%20rx='10'%20ry='10'%20width='60'%20height='60'%20fill='rgba(169,%20174,%20184,%200.1)'%20stroke='rgba(169,%20174,%20184,%200.2)'%20stroke-width='1'%20opacity='0.5'%3e%3canimateTransform%20attributeType='XML'%20attributeName='transform'%20begin='0s'%20dur='30s'%20type='rotate'%20from='0%201450%20550'%20to='360%201450%20550'%20repeatCount='indefinite'/%3e%3c/rect%3e%3c/svg%3e");
  background-size: 100% 100%;
}
.login-title {
  font-size: 50px;
  font-weight: 500;
  color: #333333;
  text-align: center;
  padding-top: 100px;
  padding-bottom: 100px;
}
.login-content {
  width: 100%;
  position: relative;
  display: flex;
  padding: 0 10%;
  .login-bg {
    width: 68%;
    height: 80%;
  }
  .content-form {
    flex: 1;
    height: 600px;
    right: 50px;
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
    padding: 20px 40px;
    h1 {
      font-size: 30px;
      font-weight: 600;
      color: #333333;
      text-align: center;
      margin: 60px 0;
    }
    .form-box {
      ::v-deep .ant-input-prefix {
        font-size: 26px;
      }
      ::v-deep .ant-input {
        border-radius: 40px;
        height: 50px;
        padding-left: 45px;
        font-size: 20px;
      }
      ::v-deep .ant-input-password {
        .ant-input-suffix {
          right: 20px;
          .anticon {
            font-size: 20px;
          }
        }
      }
      ::v-deep.code-input {
        .ant-input {
          padding-left: 20px;
        }
        .ant-input-suffix {
          height: 45px;
          width: 110px;
          display: flex;
          padding: 4px;
          align-items: center;

          margin-right: -10px;
          .code-img {
            width: 100%;
            height: 100%;
            background: skyblue;
            border-radius: 30px;
          }
        }
      }
      .err-msg-form {
        position: relative;
        top: -20px;
        margin-bottom: 0;
        .err-msg {
          padding: 0 20px;
          color: red;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
          overflow: hidden;
        }
      }
      .login-btn {
        height: 50px;
        width: 100%;
        border-radius: 30px;
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        line-height: 48px;
        background: #079a92;
        border: 0 !important;
      }
    }
  }
}
</style>
